import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { AppContext } from '@prisjakt/ui-app-context';
import {
  productPriceClick,
  productClickOutBounce,
} from '../../actions/product';
import { AppState } from '../../../../reducers';
import { PriceListProps, PriceListStateProps } from './types';
import { PriceListPanel } from './price-list-panel';
import { PriceListPanelWrapper } from './styles';

const PriceList: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<PriceListProps>
>> = props => {
  const {
    productId,
    category,
    me,
    priceList,
    filteredOffers,
    conditions,
    ...priceListPanelProps
  } = props;

  const { market } = useContext(AppContext);
  return (
    <PriceListPanelWrapper>
      <PriceListPanel
        me={me}
        productId={productId}
        showProductInformationTexts={market.showProductInformationTexts}
        storeStatistics={priceList?.meta?.storeStatistics}
        filteredOffers={filteredOffers}
        {...priceListPanelProps}
      />
    </PriceListPanelWrapper>
  );
};

const mapStateToProps = (state: AppState): PriceListStateProps => ({
  me: state.areas.account.me,
});

const dispatchProps = {
  dispatchProductPriceClick: productPriceClick,
  dispatchProductClickOutBounce: productClickOutBounce,
};

export default connect(mapStateToProps, dispatchProps)(PriceList);
